(function (angular) {
    'use strict';

    angular
     .module('dentist')
     .factory('dentistService', ['$http', '$rootScope', '$interpolate', dentistServiceFactory]);

    function dentistServiceFactory($http, $rootScope, $interpolate) {

        var dentistService = {
            getAllPracticeBusinessCards: getAllPracticeBusinessCards,
            getAllServicesAndPractitionersInPractice: getAllServicesAndPractitionersInPractice,
            getCoupon: getCoupon,
            insertBookingInformation: insertBookingInformation,
            getPracticeProfileWithPublishedTreatmentExperiencesAndPublishedReponses: getPracticeProfileWithPublishedTreatmentExperiencesAndPublishedReponses
        };

        return dentistService;

        function getAllPracticeBusinessCards(region) {
            var config = { params: { region: region } };
//        	var url = "http://env-5650710.appengine.flow.ch/api/practices/withGroupedTreatmentsAndFreeTimeSlots";
            var url = "/api/practices/withGroupedTreatmentsAndFreeTimeSlots";
            return $http.get(url, config)
            .then(getAllComplete)
            .catch(getAllError);
            
            function getAllComplete(response) {
                return response;
            }
            
            function getAllError(error) {
                // any error logging goes here
                console.log(error);
                
                throw error;
            }
        };
        function getAllServicesAndPractitionersInPractice(practiceParam, standalone) {
        	var config = { params: { standalone: standalone } };
//        	var url = "http://env-5650710.appengine.flow.ch/api/practices/withPractitionersAndGroupedTreatments/{{practiceId}}";
        	var url = "/api/practices/withPractitionersAndGroupedTreatments/{{practiceId}}";
            return $http.get($interpolate(url)(practiceParam), config)
                .then(getAllComplete)
				    .catch(getAllError);

            function getAllComplete(response) {
                return response;
            }

            function getAllError(error) {
                // any error logging goes here
                console.log(error);
                
                if(error.status == 404) {
                	return { data: { practitioners: {} } };
                }

                throw error;
            }
        };

        function getCoupon(couponCode) {
//        	var url = "http://env-5650710.appengine.flow.ch/api/coupons/byCode/{{couponCode}}";
            var url = "/api/coupons/byCode/{{couponCode}}";
            return $http.get($interpolate(url)({couponCode: couponCode}))
            .then(getAllComplete)
            .catch(getAllError);
            
            function getAllComplete(response) {
                return response;
            }
            
            function getAllError(error) {
                // any error logging goes here
                console.log(error);
                
                throw error;
            }
        };

        function insertBookingInformation(obj) {
//            return $http.post("http://env-5650710.appengine.flow.ch/api/insertBookingInformation", obj)
            return $http.post("/api/insertBookingInformation", obj)
                .then(getAllComplete)
				    .catch(getAllError);

            function getAllComplete(response) {
                return response;
            }

            function getAllError(error) {
                // any error logging goes here
                console.log(error);

                throw error;
            }
        };
        
        function getPracticeProfileWithPublishedTreatmentExperiencesAndPublishedReponses(id) {
        	var url = "/api/practices/withProfileAndPublishedTreatmentExperiences/{{id}}";
            return $http.get($interpolate(url)({ id: id }))
                .then(getAllComplete)
				    .catch(getAllError);

            function getAllComplete(response) {
                return response;
            }

            function getAllError(error) {
                // any error logging goes here
                console.log(error);

                throw error;
            }
      };

    }
})(window.angular);